// auto-initialize GridVue
$(function () {
    var gvs = $('.gridvue');
    gvs.attr('v-cloak', 'true');
    if (gvs.length) {
        //require(['css!selerix_common/lib/gridvue/gridvue']);
        require(['gridvue'], function (a) {
            gvs.each(function (i) {
                var el = $(this);
                if (el.attr('id') === void 0 || el.attr('id') === null) el.attr('id', 'gridvue_' + i);
                if (el.data('mounted') || el.data('initialize') === false) { el.attr('v-cloak', null); return; }
                var gv = new a.GridVue('#' + el.attr('id'));
                gv.mount(gv.selector);
            });
        });
    }
});

// theme helper
var ThemeHelper = {
    el: null,
    // add theme login background to element
    addBackgroundTo: function (selector, cssClass, bgCover) {
        // check for valid selector
        if (!selector) {
            return;
        }

        // check for element existing
        el = selector instanceof jQuery ? selector : $(selector);
        if (!el.length) {
            return;
        }

        // set defaults if params are undefined
        var cls = cssClass || 'bg-login';
        var cover = bgCover === void 0 ? true : bgCover;

        // add the bg-login class to element
        if (!el.hasClass(cls)) {
            el.addClass(cls);

            // apply background cover class
            if (cover) {
                // add bg-cover only if theme image applied
                if (el.css('background-image').indexOf('theme') > -1 && !el.hasClass('bg-cover')) {
                    el.addClass('bg-cover');
                }

                // adjust background on browser resize
                $(window).off('resize.theme').on('resize.theme', function () {
                    var isTheme = el.css('background-image').indexOf('theme') > -1;
                    if (isTheme && !el.hasClass('bg-cover')) {
                        el.addClass('bg-cover');
                    } else if (!isTheme) {
                        el.removeClass('bg-cover');
                    }
                });
			}
        }
    },
    // replace image source for element with theme login image
    replaceImageOn: function (selector) {
        // check for valid selector
        if (!selector) {
            return;
        }

        // check for element existing
        el = selector instanceof jQuery ? selector : $(selector);
        if (!el.length) {
            return;
        }

        // test for login image
        el.addClass('bg-login');
        if (el.css('background-image').indexOf('theme') > -1) {
            // replace image src
            var url = el.css('background-image').replace(/(^url\((\'|\"))|((\'|\")\);)/g, '');
            el.prop('src', url);
            el.removeClass('bg-login');
		}
    }
};

// password show/hide toggler
var PasswordToggle = function (input, button, callback) {
    var that = this;
    that.input = input instanceof jQuery ? input : $(input);
    that.button = button instanceof jQuery ? button : $(button);

    // constants
    var open = 'glyphicons-eye-open';
    var close = 'glyphicons-eye-close';

    // click event for button
    that.addEventHandler = function () {
        that.button.off('click.pwtoggle').on('click.pwtoggle', function () {
            var el = $(this);
            if (el.hasClass(open)) {
                el.removeClass(open);
                el.addClass(close);
                that.input.prop('type', 'text');
            } else {
                el.removeClass(close);
                el.addClass(open);
                that.input.prop('type', 'password');
            }
        });
    };

    // initialization
    (function () {
        // set default state
        that.input.prop('type', that.button.hasClass('glyphicons-eye-close') ? 'text' : 'password');

        // add toggle event
        that.addEventHandler();

        // execute callback
        if (typeof callback === 'function') {
            callback.call(that);
		}
    })();
};